import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { mediaQueries } from 'src/style/breakpoints';

const LogoLeReacteurLanding = () => {
  return (
    <div
      css={{
        [mediaQueries.phoneOnly]: {
          display: 'flex',
          justifyContent: 'center',
          marginBottom: 30,
        },
      }}
    >
      <StaticImage
        src="../../data/images/logo-le-reacteur.png"
        alt="Le Reacteur - Logo"
        // placeholder="none"
        css={{
          width: 300,
          borderRadius: 5,
          marginBottom: 30,
        }}
      />
    </div>
  );
};

export default LogoLeReacteurLanding;
